import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-custom-loader',
  standalone: true,
  imports: [MatProgressSpinnerModule, CommonModule],
  template: `
    <div *ngIf="loading" class="ball-scale-multiple">
      <div class="wrapper relative">
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  `,
  styles: [
    `
      .ball-scale-multiple {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.2);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 999;
        border-radius: 4px;
      }
      .ball-scale-multiple .wrapper div {
        position: absolute;
        left: -30px;
        top: -30px;
        width: 60px;
        height: 60px;
        background: rgb(255, 255, 255);
        border-radius: 100%;
        opacity: 0;
        -webkit-animation: ball-scale-multiple 1s linear infinite;
      }
      .ball-scale-multiple .wrapper div:nth-child(2) {
        -webkit-animation-delay: 0.2s;
      }
      .ball-scale-multiple .wrapper div:nth-child(3) {
        -webkit-animation-delay: 0.4s;
      }
      @-webkit-keyframes ball-scale-multiple {
        0% {
          -webkit-transform: scale(0);
          opacity: 0;
        }
        5% {
          opacity: 1;
        }
        100% {
          -webkit-transform: scale(1);
          opacity: 0;
        }
      }
    `,
  ],
})
export class CustomLoaderComponent {
  @Input() loading = false;
}
